// User object that is shared publicly

import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import {
  empty,
  type FirestoreRoomStateSummary,
} from '../firestore/RoomStateSummary'
import type { FirebaseRepository } from './FirebaseRepository'

export class RoomStateSummary extends ObservableModelWithDecorators<FirestoreRoomStateSummary> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreRoomStateSummary>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
